<template>
  <div class="confirm uk-container uk-width-1-1">
    <form class="uk-panel uk-panel-box uk-form">
      <div class="uk-margin">
        <input v-model="username" class="uk-width-1-1 uk-form-large" type="email" placeholder="Mail Address" required>
      </div>
      <div class="uk-margin">
        <input v-model="confirmationCode" class="uk-width-1-1 uk-form-large" type="text" placeholder="Activation Key" required>
      </div>
      <div class="uk-margin">
        <button class="uk-width-1-1 uk-button uk-button-secondary uk-button-large">Activation</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Confirm',
  data () {
    return {
      username: '',
      confirmationCode: ''
    }
  },
  methods: {
    confirm () {
      this.$cognito.confirmation(this.username, this.confirmationCode)
        .then(result => {
          this.$router.replace('/login')
        })
        .then(err => {
          this.error = err
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Confirm.vue